<template>
  <div id="Agent">
    <!--  <nav class="topnav navbar navbar-expand shadow navbar-light bg-white mb-5 fixed-top" v-if="client.name != ''">
      <router-link to="/agent" class="navbar-brand">
        <img :src="client.logo" style="width:30px; height:30px" alt class="mr-2" />
        <span class="font-weight-bold">{{client.name}}</span>
        <small>- Agent</small>
      </router-link>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarSupportedContent">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <router-link to="/agent" class="nav-link">
              <i class="fa fa-home ml-5"></i> Home
              <span class="sr-only">(current)</span>
            </router-link>
          </li>
          <li class="nav-item active">
            <router-link to="/agent/tickets/open" class="nav-link">
              <i class="fa fa-stop text-danger"></i> Open
            </router-link>
          </li>
          <li class="nav-item active">
            <router-link to="/agent/tickets/escalated" class="nav-link">
              <i class="fa fa-stop text-warning"></i> Escalated
            </router-link>
          </li>
          <li class="nav-item active">
            <router-link to="/agent/tickets/closed" class="nav-link">
              <i class="fa fa-stop text-success"></i> Closed
            </router-link>
          </li>
        </ul>

        <form class="form-inline my-2 my-lg-0 mr-5" @submit.prevent="searchHandle">
          <input class="form-control mr-sm-2" type="search" placeholder="e.g. 0527-M9JA8U" aria-label="Search" />
          <button class="btn btn-info my-2 my-sm-0" type="submit">Search</button>
        </form>

        <ul class="navbar-nav mr-5">
          <li class="nav-item dropdown">
            <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{authUser.name}}</a>
            <div class="dropdown-menu" aria-labelledby="navbarDropdown" style="left: -120px !important">
              <div style="width: 100%; text-align:center; padding: 20px ">
                <b>{{authUser.name}}</b>
                <br />
                {{authUser.email}}
                <br />
              </div>
              
              <div class="dropdown-divider"></div>
              <span class="dropdown-item" @click="logout">Logout</span>
            </div>
          </li>
        </ul>
      </div>
    </nav>-->

    <nav class="topnav navbar navbar-expand shadow navbar-light bg-white" id="sidenavAccordion">
      <router-link to="/agent" class="navbar-brand d-sm-block">
        <img :src="client.logo" style="height: 30px" alt class="mr-1" />
        <!-- {{ client.shortName }} -->
      </router-link>
      <!-- Search form -->
      <!-- <form @submit.prevent="searchHandle" class="form-inline mr-auto d-none d-lg-block">
        <input class="form-control form-control-solid mr-sm-2" type="search" placeholder="Search" aria-label="Search" />
      </form>-->

      <!-- right memu -->
      <ul class="navbar-nav align-items-center ml-auto">
        <li class="nav-item no-caret mr-3 desktopMenu">
          <router-link to="/agent" class="nav-link dropdown-toggle" id="navbarDropdownDocs" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="d-none d-md-inline font-weight-500">Home</div>
          </router-link>
        </li>

        <li class="nav-item no-caret mr-3 desktopMenu">
          <router-link :to="{ name: 'CreateTicketAgent' }" class="nav-link dropdown-toggle" id="navbarDropdownDocs" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="d-none d-md-inline font-weight-500">Create a Ticket</div>
          </router-link>
        </li>
        <li class="nav-item no-caret mr-3 desktopMenu">
          <router-link :to="{ name: 'MyTicketsAgent' }" class="nav-link dropdown-toggle" id="navbarDropdownDocs" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="d-none d-md-inline font-weight-500">My Tickets</div>
          </router-link>
        </li>

        <li class="nav-item no-caret mr-3 desktopMenu">
          <router-link to="/agent/tickets/open" class="nav-link dropdown-toggle" id="navbarDropdownDocs" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <!-- <div class="d-inline d-md-none font-weight-500">Tickets</div> -->
            <div class="d-none d-md-inline font-weight-500"><i class="fa fa-stop text-danger"></i> Open</div>
          </router-link>
        </li>
        <li class="nav-item no-caret mr-3 desktopMenu">
          <router-link to="/agent/tickets/escalated" class="nav-link dropdown-toggle" id="navbarDropdownDocs" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <!-- <div class="d-inline d-md-none font-weight-500">Tickets</div> -->
            <div class="d-none d-md-inline font-weight-500"><i class="fa fa-stop text-warning"></i> Escalated</div>
          </router-link>
        </li>
        <li class="nav-item no-caret mr-3 desktopMenu">
          <router-link to="/agent/tickets/closed" class="nav-link dropdown-toggle" id="navbarDropdownDocs" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <!-- <div class="d-inline d-md-none font-weight-500">Tickets</div> -->
            <div class="d-none d-md-inline font-weight-500"><i class="fa fa-stop text-success"></i> Closed</div>
          </router-link>
        </li>

        <!-- mobile search -->
        <li class="nav-item dropdown no-caret mr-3 mobileMenu">
          <!-- <a class="btn btn-icon btn-transparent-dark dropdown-toggle" id="navbarDropdownUserImage" href="javascript:void(0);" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="d-inline d-md-none font-weight-500">
              <i class="fas fa-search"></i>
            </div>
          </a>-->
          <!-- <div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up py-0 o-hidden" aria-labelledby="navbarDropdownUserImage">
            <div class="dropdown-item">
              <form @submit.prevent="searchHandle" class="form-inline mr-auto d-lg-block">
                <input class="form-control form-control-solid mr-sm-2" type="search" placeholder="Search" aria-label="Search" style="width: auto !important" />
              </form>
            </div>
          </div>-->
        </li>
        <!-- mobile menu -->
        <li class="nav-item dropdown no-caret mr-3 mobileMenu">
          <a class="btn btn-icon btn-transparent-dark dropdown-toggle" id="navbarDropdownUserImage" href="javascript:void(0);" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <div class="d-inline d-md-none font-weight-500">
              <i class="fas fa-bars"></i>
            </div>
          </a>
          <div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up" aria-labelledby="navbarDropdownUserImage">
            <router-link to="/agent" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i class="fas fa-home"></i>
              </div>
              Home
            </router-link>

            <router-link :to="{ name: 'CreateTicketAgent' }" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i class="fas fa-book"></i>
              </div>
              Create a Ticket
            </router-link>

            <router-link :to="{ name: 'MyTicketsAgent' }" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i class="fas fa-book"></i>
              </div>
              My Tickets
            </router-link>

            <router-link to="/agent/tickets/open" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i class="fa fa-stop text-danger"></i>
              </div>
              Open
            </router-link>

            <router-link to="/agent/tickets/escalated" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i class="fa fa-stop text-warning"></i>
              </div>
              Escalated
            </router-link>

            <router-link to="/agent/tickets/closed" class="dropdown-item">
              <div class="dropdown-item-icon">
                <i class="fa fa-stop text-success"></i>
              </div>
              Closed
            </router-link>
          </div>
        </li>

        <!-- auth user -->
        <li class="nav-item dropdown no-caret mr-1 dropdown-user">
          <a class="btn btn-icon btn-transparent-dark dropdown-toggle" id="navbarDropdownUserImage" href="javascript:void(0);" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <img class="img-fluid" :src="authUser.photo" style="width: 60px" />
          </a>
          <div class="dropdown-menu dropdown-menu-right border-0 shadow animated--fade-in-up" aria-labelledby="navbarDropdownUserImage">
            <h6 class="dropdown-header d-flex align-items-center">
              <img class="dropdown-user-img" :src="authUser.photo" />
              <div class="dropdown-user-details">
                <div class="dropdown-user-details-name">{{ authUser.name }}</div>
                <div class="dropdown-user-details-email">{{ authUser.email }}</div>
                <div class="dropdown-user-details-email">{{ client.agentLabel }} ({{ authUser.roleName }})</div>
              </div>
            </h6>
            <div class="dropdown-divider"></div>
            <!-- <a class="dropdown-item" href="#!">
              <div class="dropdown-item-icon">
                <i data-feather="settings"></i>
              </div>Account
            </a>-->
            <router-link class="dropdown-item" :to="{ name: 'UserProfileAgent' }" style="cursor: pointer">
              <div class="dropdown-item-icon">
                <i data-feather="log-out"></i>
              </div>
              Profile
            </router-link>

            <!-- Logout menu -->
            <Logout type="menu"></Logout>
          </div>
        </li>
      </ul>
    </nav>

    <div id="layoutSidenav">
      <div id="layoutSidenav_content">
        <router-view />

        <!-- footer -->
        <footer class="footer mt-auto footer-light">
          <div class="container-fluid">
            <div class="row">
              <div class="col-md-6 small">{{ copyright }}</div>
              <div class="col-md-6 text-md-right small">
                Powered by
                <a href="https://coregrade.co" target="_blank">Coregrade</a>
              </div>
            </div>
          </div>
        </footer>
        <!-- footer -->
      </div>
    </div>
  </div>
</template>

<script>
import Logout from "@/components/Logout.vue";
import brand from "../helper/brand";

export default {
  name: "Agent",

  mounted() {
    this.$store.dispatch("getClient");
  },

  methods: {
    searchForm() {
      this.$router.push({
        name: "Search",
        params: { query: this.searchQuery },
      });
      this.searchQuery = "";
      this.searchFormStatus = false;
    },
  },

  computed: {
    client() {
      let client = this.$store.state.client;
      if (client.name == "") {
        this.$router.push({ name: "AccountNotFound" });
      }
      return client;
    },

    authUser() {
      return this.$store.state.authUser;
    },

    copyright() {
      let d = new Date();
      return `Copyright ©${d.getFullYear()} ${this.$store.state.client.shortName}`;
    },
  },

  /*   updated() {
    brand.headerGradient(this.client.color, this.client.color2);
  } */

  components: {
    Logout,
  },
};
</script>

<style >
@import "https://cdn.jsdelivr.net/npm/animate.css@3.5.1";
/* body {
  padding-top: 100px;
} */
.page-header-subtitle {
  margin-left: 10px !important;
}
/* .dropdown-item {
  cursor: pointer;
} */
@media (max-width: 576px) {
  .desktopMenu {
    display: none;
  }
}
@media (min-width: 576px) {
  .mobileMenu {
    display: none;
  }
}
#layoutSidenav #layoutSidenav_content {
  margin-left: 0;
}
</style>
